import React from 'react';
import { BaseMonitoringToolkit, baseMonitoringToolkitHelper } from './implementations/base-monitoring-toolkit';
import { CentralMonitoringToolkit, centralMonitoringToolkitHelper } from './implementations/central-monitoring-toolkit';
import {
    SubjectMonitoringToolkit,
    SubjectMonitoringToolkitContexts,
    subjectMonitoringToolkitHelper,
} from './implementations/subject-monitoring-toolkit';
import {
    RiskAssessmentToolkit,
    RiskAssessmentToolkitContexts,
    riskAssessmentToolkitHelper,
} from '@components-clean/core/monitoring-toolkit/implementations/ram-monitoring-toolkit';
import { IMonitoringToolkit } from '@components-clean/core/monitoring-toolkit/interface';
import { MonitoringToolkitWrapperProps } from '@pages-clean/central-monitoring/monitoring-toolkit/wrapper';
import Modules, { IModule } from '@config/modules';

type Props = Omit<MonitoringToolkitWrapperProps, 'toolkitHelper'> & {
    module: IModule;
};
export const MonitoringToolkit = ({ module, ...props }: Props) => {
    switch (module) {
        case Modules.SubjectMonitoring:
            return (
                props.study?.id != null && (
                    <SubjectMonitoringToolkitContexts studyRef={props.study.id}>
                        <SubjectMonitoringToolkit {...props} />
                    </SubjectMonitoringToolkitContexts>
                )
            );
        case Modules.CentralMonitoring2:
            return <CentralMonitoringToolkit {...props} />;
        case Modules.RiskAssessment:
            return (
                <RiskAssessmentToolkitContexts>
                    <RiskAssessmentToolkit {...props} />
                </RiskAssessmentToolkitContexts>
            );
        default:
            return <BaseMonitoringToolkit {...props} />;
    }
};

export const getMonitoringToolkitHelper = (module: IModule): IMonitoringToolkit => {
    switch (module) {
        case Modules.SubjectMonitoring:
            return subjectMonitoringToolkitHelper;
        case Modules.CentralMonitoring2:
            return centralMonitoringToolkitHelper;
        case Modules.RiskAssessment:
            return riskAssessmentToolkitHelper;
        default:
            return baseMonitoringToolkitHelper;
    }
};
